const PAGE_SIZE = 20;

export const actionTypes = {
	SetLoading: '[Feed] SetLoading',
	AddPosts: '[Feed] SavePosts',
	AddRefreshCommunityPost: '[Feed] AddRefreshCommunityPost',
	RemovePostId: '[Feed] RemovePostId',
	UpdatePost: '[Feed] UpdatePost',
	SetPosts: '[Feed] SetPosts',
	SetAdminId: '[Feed] SetAdminId',
	AddComment: '[Feed] AddComment',
	ToggleLike: '[Feed] ToggleLike',
	BanUser: '[Feed] BanUser',
	DeletePost: '[Feed] DeletePost',
	DeleteComment: '[Feed] DeleteComment',
	SetCustomerService: '[Feed] SetCustomerService',
	RefreshCommunityPost: '[Feed] RefreshCommunityPost',
	RefreshCommunityComment: '[Feed] RefreshCommunityComment',
};

export const initialFeedState = {
	posts: [],
	loading: false,
	allLoaded: false,
	postIdToUpdate: '',
	refreshCommunityPost: null,
	refreshCommunityComment: null,
};

export const reducer = (state = initialFeedState, action) => {
	switch (action.type) {
		case actionTypes.SetLoading:
			return {
				...state,
				loading: action.payload,
			};
		case actionTypes.AddPosts:
			return {
				...state,
				posts: [...state.posts, ...action.payload],
				loading: false,
				allLoaded: action.payload.length < PAGE_SIZE,
			};
		case actionTypes.AddRefreshCommunityPost:
			return {
				...state,
				posts: [action.payload, ...state.posts],
				loading: false,
				allLoaded: action.payload.length < PAGE_SIZE,
			};
		case actionTypes.UpdatePost:
			return {
				...state,
				postIdToUpdate: action.payload,
			};
		case actionTypes.RemovePostId:
			return {
				...state,
				postIdToUpdate: '',
			};
		case actionTypes.SetPosts:
			return {
				...state,
				posts: action.payload || [],
				loading: false,
				allLoaded: action.payload.length < PAGE_SIZE,
			};
		case actionTypes.SetAdminId:
			return {
				...state,
				adminId: action.payload || '',
			};
		case actionTypes.AddComment:
			return {
				...state,
				posts: state.posts.map(p =>
					p._id === action.payload.postId
						? {
							...p,
							comments: [...p.comments, action.payload],
						}
						: p,
				),
			};
		case actionTypes.ToggleLike:
			return {
				...state,
				posts: state.posts.map(p =>
					p._id === action.payload.postId
						? {
							...p,
							iLiked: !p.iLiked,
							likes: p.iLiked ? p.likes - 1 : p.likes + 1,
						}
						: p,
				),
			};
		case actionTypes.BanUser:
			return {
				...state,
				posts: state.posts.map(p => ({
					...p,
					user: {
						...p.user,
						banned: p.user._id === action.payload ? true : p.user.banned,
					},
				})),
			};
		case actionTypes.DeletePost:
			return {
				...state,
				posts: state.posts.filter(p => p !== action.payload),
			};
		case actionTypes.DeleteComment:
			return {
				...state,
				posts: state.posts.map(p =>
					p._id === action.payload.postId
						? {
							...p,
							comments: p.comments.filter(c => c._id !== action.payload.commentId),
						}
						: p,
				),
			};
		case actionTypes.SetCustomerService:
			return {
				...state,
				posts: state.posts.map(p =>
					p._id === action.payload.postId
						? {
							...p,
							customerService: true,
						}
						: p,
				),
			};
		case actionTypes.RefreshCommunityPost:
			return {
				...state,
				refreshCommunityPost: action.payload.message?.comment?.postId || action.payload.message?.post?.guid,
			};
		case actionTypes.RefreshCommunityComment:
			const { postId, text } = action.payload;
			return {
				...state,
				refreshCommunityComment: {
					postId,
					text
				},
			};
		default:
			return state;
	}
};

export const actions = {
	addPosts: payload => ({ type: actionTypes.AddPosts, payload }),
	addRefreshCommunityPost: payload => ({ type: actionTypes.AddRefreshCommunityPost, payload }),
	refreshCommunityComment: payload => ({ type: actionTypes.RefreshCommunityComment, payload }),
	removePostId: payload => ({ type: actionTypes.RemovePostId, payload }),
	setPosts: payload => ({ type: actionTypes.SetPosts, payload }),
	setAdminId: payload => ({ type: actionTypes.SetAdminId, payload }),
	setLoading: payload => ({ type: actionTypes.SetLoading, payload }),
	addComment: payload => ({ type: actionTypes.AddComment, payload }),
	toggleLike: payload => ({ type: actionTypes.ToggleLike, payload }),
	banUser: payload => ({ type: actionTypes.BanUser, payload }),
	deletePost: payload => ({ type: actionTypes.DeletePost, payload }),
	deleteComment: payload => ({ type: actionTypes.DeleteComment, payload }),
	setCustomerService: payload => ({ type: actionTypes.SetCustomerService, payload }),
	refreshCommunityPost: payload => ({ type: actionTypes.RefreshCommunityPost, payload }),
};